import React, { useEffect, useState } from 'react'
import { useList } from '../custom-hooks/api-hooks'
import { Link, useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { Button, Intent, H4, ButtonGroup, Alert } from '@blueprintjs/core'
import organizationsService from '../../api-services/organizations-service'
import authenticationServices from '../../authentication-services'
import usersService from '../../api-services/users-service'
import DashboardElement from '../layout/dashboard-element/dashboard-element'
import DetailsBox from '../commons/details-box/details-box'
import FormElement from '../commons/form-group/form-group'
import PatientsTable from '../commons/patients-table/patients-table'
import { serverErrorToast, successToast } from '../layout/toaster/toaster'

function Organization ({ organization }) {
  const { role } = authenticationServices.authenticationData
  const [isDeleteOpen, setIsDeleteOpen] = useState(false)
  const [isInviteOpen, setIsInviteOpen] = useState(false)
  const [isPasswordChangeOpen, setIsPasswordChangeOpen] = useState(false)
  const [organizations, setOrganizations] = useState()
  const [selectedUser, setSelectedUser] = useState()

  const [users, setUsers] = useState([])

  useList(organizationsService, setOrganizations)
  const { register, handleSubmit, errors, reset } = useForm()
  const history = useHistory()

  async function fetchData () {
    let users = await usersService.fetch({organizationId: organization._id})
    setUsers(users)
  }

  useEffect(() => {
    fetchData()
  }, [organization._id])

  const deleteOrganization = async () => {
    try {
      await organizationsService.delete(organization._id)
      successToast(`Organization was successfully removed`)
      history.push('/organizations')
    } catch (err) {
      serverErrorToast(err)
      setIsDeleteOpen(false)
    }
  }

  const onPasswordChange = async ({password}) => {
    try {
      let successText = 'Successfully changed user password for: ' + selectedUser.firstName + ' ' + selectedUser.lastName
      let data = await usersService.patchWithUrl('changepassword', { email:selectedUser.email, password:password })
      if (!data) {
        successText = 'Failed to change user password for ' + selectedUser.firstName + ' ' + selectedUser.lastName
      }
      alert(successText)

    } catch (error) {
      const errorText = 'Failed to delete user ' + selectedUser.firstName + ' ' + selectedUser.lastName
      alert(errorText)
    }

    reset()
    setIsPasswordChangeOpen(false)
  }

  const onSelectPatient = async(p) => {
    history.push(`/patients/${p._id}`)
  }

  const showPasswordChange = async(u) => {
    setSelectedUser(u)
    setIsPasswordChangeOpen(true)
  }


  const onInviteUser = async ({ firstName, lastName, password, email }) => {
    try {
      await usersService.post({
        name: firstName + " " + lastName,
        firstName: firstName,
        lastName: lastName,
        type:"pharmacy",
        email:email,
        password:password,
        organizationId: organization._id,
        organizationName: organization.name,
      })
      successToast(`User was successfully invited by email: ${email}`, null)
      setIsInviteOpen(false)

      const users = await usersService.fetch({organizationId: organization._id})
      setUsers(users)

      reset()
    } catch (err) {
      serverErrorToast(err)
    }
  }

  const { _id, name, timezone, createdAt, salesforceId, type, shortId } = organization
  const { contactName, email, phone, address, city, state, country, zip } = {}
  const parent = organizations ? organizations.find(o => o._id === organization.parentId) : null

  return (
    <>
      <DashboardElement style={{ height: 'fit-content' }}>
        <DetailsBox title={`${name}`}
          primaryActionButton={
            <ButtonGroup>
                <>
                { role === 'admin' && <Button icon='print' onClick={() => window.open(`/report-organization/${_id}`, '_blank')}>Report</Button> }
                  { role === 'admin' && <Button intent={Intent.PRIMARY} icon='edit' onClick={() => history.push(`/organizations/${_id}/edit`)}>Edit</Button>}
                  { (role === 'admin' || role === 'pharmacy' ) && <Button intent={Intent.WARNING} icon='new-person' onClick={() => setIsInviteOpen(true)}>Add CueMed Admin User</Button> }
                  { role === 'admin' && <Button intent={Intent.DANGER} icon='trash' onClick={() => setIsDeleteOpen(true)}>Delete</Button> }
                </>
            </ButtonGroup>
          }>
          <DetailsBox.Item text='Type' value={type} />
          <DetailsBox.Item text='Rx/HCA ID' value={shortId} />
          { role !== 'pharmacy' && <DetailsBox.Item text='Salesforce ID' value={salesforceId} />}
          <DetailsBox.Item text='Parent' value={parent && <Link to={`/organizations/${parent._id}`}>{parent.name}</Link>} />
          <DetailsBox.Item text='Contact Name' value={contactName} />
          <DetailsBox.Item text='Phone' value={phone} />
          <DetailsBox.Item text='Email' value={email} />
          <DetailsBox.Item text='Address' value={city ? `${city}, ${state} ${address}, ${zip}, ${country}` : null} />
          <DetailsBox.Item text='Timezone' value={timezone} />
          <DetailsBox.Item text='Created At' value={createdAt && createdAt.toString()} />
        </DetailsBox>
      </DashboardElement>
      <DashboardElement style={{ height: 'fit-content' }}>
        <H4>Patients List</H4>
        <PatientsTable patients={organization.patients} />
      </DashboardElement>
      <div style={{padding:'20px'}}>
        <H4>CueMed Mobile App Users</H4>

        <table style={{ border: '1px solid black', width: '90%', 'border-collapse': 'collapse' }}>
           <tr style={{ border: '1px solid black', 'background-color': '#0f9960' }}>
            <th style={{ border: '1px solid black' }}>First</th>
            <th style={{ border: '1px solid black' }}>Last</th>
            <th style={{ border: '1px solid black' }}>Email</th>
            <th style={{ border: '1px solid black' }}>Type</th>
            <th style={{ border: '1px solid black' }}>Patients</th>
            <th style={{ border: '1px solid black' }}>Action</th>
          </tr>

          {
          (users && users.length > 0) &&
            users.sort((a, b) => a.firstName < b.firstName ? 1 : -1).map(u => {
              return (
                <tr>
                  <td style={{ border: '1px solid black', padding: '5px', 'justify-content': 'center'  }}>
                    <b> {u.firstName} </b>
                  </td>
                  <td style={{ border: '1px solid black', padding: '5px', 'justify-content': 'center'  }}>
                    <b> {u.lastName} </b>
                  </td>
                  <td style={{ border: '1px solid black', padding: '5px', 'justify-content': 'center'  }}>
                    <b> {u.email} </b>
                  </td>
                  <td style={{ border: '1px solid black', padding: '5px', 'justify-content': 'center'  }}>
                    <b> {u.type} </b>
                  </td>
                  <td style={{ border: '1px solid black', padding: '5px', 'justify-content': 'center'  }}>
                    {(u.patients.length >0) && u.patients.map( p => (
                      <div>
                        <Button intent="primary" variant="minimal"  minimal={true} onClick={() => onSelectPatient(p)}>{p._id}</Button>
                      </div>
                    ))}
                  </td>
                  <td style={{ border: '1px solid black', padding: '5px', 'justify-content': 'center' }}>
                    <Button text="Change Password" intent={Intent.WARNING} icon='cog' onClick={() => showPasswordChange(u)}/>
                  </td>
                </tr>
              )
            })
          }

          {
            (users.length === 0) && <tr><p style={{ padding: '5px' }}> No CueMed admin users has been added to organization.</p></tr>
          }

       </table>
      </div>
      <Alert
        cancelButtonText='Cancel'
        confirmButtonText='Delete Organization'
        icon='trash'
        intent={Intent.DANGER}
        isOpen={isDeleteOpen}
        onCancel={() => setIsDeleteOpen(false)}
        onConfirm={deleteOrganization}
      >
        <p>Are you sure you want to permanently delete "{name}" organization?</p>
      </Alert>
      <Alert
        cancelButtonText='Cancel'
        confirmButtonText='Invite User'
        icon='new-person'
        intent={Intent.SUCCESS}
        isOpen={isInviteOpen}
        onCancel={() => setIsInviteOpen(false)}
        onConfirm={handleSubmit(onInviteUser)}
      >
        <p>Please add name and email of a person to access "{name}" organization.</p>
        <form>
          <FormElement name='firstName' inputRef={register({ required: true })} label='First Name' errors={errors} />
          <FormElement name='lastName' inputRef={register({ required: true })} label='Last Name' errors={errors} />
          <FormElement name='email' inputRef={register({ required: true, pattern: /\S+@\S+\.\S+/ })} label='Email' errors={errors} />
          <FormElement name='password' inputRef={register({ required: true })} label='Password' errors={errors} />
        </form>
      </Alert>

      <Alert
        cancelButtonText='Cancel'
        confirmButtonText='Password Change'
        icon='cog'
        intent={Intent.SUCCESS}
        isOpen={isPasswordChangeOpen}
        onCancel={() => setIsPasswordChangeOpen(false)}
        onConfirm={handleSubmit(onPasswordChange)}
      >
        <p>Choose a password more than 8 characters</p>
        <form>
          <FormElement name='password' inputRef={register({ required: true })} label='Password' errors={errors} />
        </form>
      </Alert>
    </>
  )
}

export default Organization
